import { Component,NgZone, OnInit,  AfterViewInit } from '@angular/core';
import { FrostmeasurementService } from '../../shared/services/frostmeasurement.service'
import { IFrostMeasurementStation } from '../../interfaces/IFrostMeasurementStation';
import { fromEvent, Observable, Subscription } from "rxjs";
import { debounceTime } from 'rxjs/operators';
import { olMapEventService } from '../../shared/services/olEventEmitter.service';

@Component({
  selector: 'app-stationlist',
  templateUrl: './stationlist.component.html',
  styleUrls: ['./stationlist.component.scss']
})
export class StationlistComponent implements AfterViewInit, OnInit {
  frostmeasurementstations: IFrostMeasurementStation[];
  resizeObservable$: Observable<Event>
  resizeSubscription$: Subscription
 // @Output() onsaveChanges: EventEmitter<IFrostMeasurementStation[]> = new EventEmitter();
  constructor(private olmapselection: olMapEventService,private frostmeasurementService: FrostmeasurementService, private ngzone:NgZone) { }
 
  ngOnInit(): void {
    
   
    this.resizeObservable$ = fromEvent(window, 'resize')
    this.resizeSubscription$ = this.resizeObservable$.pipe(debounceTime(500)).subscribe(evt => {
    var height = window.innerHeight;
    document.getElementById('stationlist').style.height = (height - 320).toString() + 'px';         
    });
    if (this.olmapselection.updatesubsVar == undefined) {
      this.olmapselection.updatesubsVar = this.olmapselection.invokeFeaturesupdate.subscribe((frostmeaurementstations:  IFrostMeasurementStation[]) => {
        this.frostmeasurementstations = frostmeaurementstations;
        console.log('UpdateStationList: ' + Date().toString());        
      });
    }   
   window.dispatchEvent(new Event('resize'));  
   this.updateStationlist(); 
  }

  ngAfterViewInit(): void {
   // window.dispatchEvent(new Event('resize')); 
  // this.updateStationlist(); 
  }

  ngOnDestroy() {
    this.resizeSubscription$.unsubscribe()
  }

  stationObservable ={
    next:(res:IFrostMeasurementStation[])  => this.frostmeasurementstations = res ,
    error: (e: Error)=>  console.log("stations not  retrieved. " + e),
    complete: () => console.log("stations  retrieved")        
  };

  updateStationlist() {
    this.frostmeasurementService.getStations('stations')
      .subscribe(this.stationObservable)
  }
  
}
